import { render, staticRenderFns } from "./BlockTimeSetting.vue?vue&type=template&id=3e192ca3"
import script from "./BlockTimeSetting.vue?vue&type=script&lang=js"
export * from "./BlockTimeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports